module.exports = __webpack_public_path__ + "fonts/BCC14573D90CCBEE4.eot";